module.exports = __webpack_public_path__ + "docs/t&c.da9b6b8e9c32992546ca07373c32b5af.html";